import lt10_1 from "./T10 (1).webp";
import lt10_2 from "./T10 (2).webp";
import lt10_3 from "./T10 (3).webp";
import lt10_4 from "./T10 (4).webp";

const imgLaurel10 = [lt10_1, lt10_2, lt10_3, lt10_4];

export default imgLaurel10;
